import { render, staticRenderFns } from "./couponPropertyUserDetailList.vue?vue&type=template&id=53ccd210&scoped=true"
import script from "./couponPropertyUserDetailList.vue?vue&type=script&lang=js"
export * from "./couponPropertyUserDetailList.vue?vue&type=script&lang=js"
import style0 from "./couponPropertyUserDetailList.vue?vue&type=style&index=0&id=53ccd210&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ccd210",
  null
  
)

export default component.exports